import { Injectable } from '@angular/core';
import { getAccountPlatform, PlatformType } from '../../../platform_type';
import { AccordionItem } from '../accordion_item';
import { defaultManualSetupStates } from './constants/steps_constans';
import { snippetConstants } from './constants/snippets_constants';
import { AuthService } from '@yotpo-ui/core';

@Injectable()
export class ManualSetupStateCreator {

  private secret = '';
  private instanceId: number;

  constructor(private authService: AuthService) {}

  create(allData: any): Array<AccordionItem> {
    if (allData.account && allData.account.platform) {
      this.secret = allData.account.secret;
      let platform = getAccountPlatform(allData.account.platform);
      if (allData.feature.WidgetV3.featureEnabled && allData.mainWidget.widgetInstanceId) {
        this.instanceId = allData.mainWidget.widgetInstanceId;
      }
      let extraData = this.createItemData(allData, platform);
      let accordionItems: Array<AccordionItem> = [];
      defaultManualSetupStates[platform].forEach((platformInstallationStep) => {
        let accordionItem: AccordionItem = {
          component: platformInstallationStep.template,
          id: platformInstallationStep.id,
          title: platformInstallationStep.title,
          description: platformInstallationStep.description,
          timeToComplete: platformInstallationStep.timeToComplete,
          active: false,
          data: extraData,
          nextItem: null
        };
        accordionItems.push(accordionItem);
      });
      accordionItems = this.setNextItems(accordionItems);
      if (accordionItems.length === 1) {
        let accordionItem: AccordionItem = {...accordionItems[0], active: true};
        accordionItems = [];
        accordionItems.push(accordionItem);
      }
      return accordionItems;
    } else {
      return null;
    }
  };

  createItemData(allData: any, platformType: PlatformType) {
    let extraData = {};
    let snippets = [];
    switch (platformType) {
      case PlatformType.Shopify: {
        if (allData.platformLinks) {
          extraData['themes'] = allData.platformLinks.themes;
          extraData['productLiquid'] = allData.platformLinks.productLiquid;
          extraData['themeLiquid'] = allData.platformLinks.themeLiquid;
          extraData['checkoutEditPage'] = allData.platformLinks.checkoutEditPage;
        }
        if (allData.feature.WidgetV3.featureEnabled) {
          snippets.push('yotpoJSWidgetV3');
          snippets.push('reviewsWidgetV3');
        } else {
          snippets.push('yotpoJS');
          snippets.push('reviewsWidget');
        }
        snippets.push('conversionTracking');
        break;
      }

      case PlatformType.Woocommerce: {
        snippets.push('app_key');
        snippets.push('secret');
        break;
      }

      case PlatformType.Bigcommerce: {
        snippets.push('yotpoJS');
        snippets.push('conversionTracking');
        break;
      }

      case PlatformType.Magento: {
        snippets.push('app_key');
        snippets.push('secret');
        break;
      }

      case PlatformType.Magento2: {
        snippets.push('changeWidgetLocation');
        snippets.push('app_key');
        snippets.push('secret');
        break;
      }
    }

    for (let snippet of snippets ) {
      extraData[snippet] = snippetConstants[platformType][snippet].replace(
        /:app_key/g, this.authService.getCredentials().appKey);
      extraData[snippet] = extraData[snippet].replace(
        ':secret', this.secret);
      extraData[snippet] = extraData[snippet].replace(
        ':widget_instance_id', this.instanceId);
    }

    return extraData;
  }

  setNextItems(accordionItems: Array<AccordionItem>): Array<AccordionItem> {
    let result: Array<AccordionItem> = [];
    for (let i = 0; i < accordionItems.length - 1; i++) {
      result.push({...accordionItems[i], nextItem: accordionItems[i + 1]});
    }
    result.push(accordionItems[accordionItems.length - 1]);
    return result;
  }
}
